import debounce from "lodash/debounce";
import { apiToggleFavouriteSignal } from "@/Groups/Signals/private/api/reactionsApi";

export const toggleFavouriteOptimistic = ({ state, commit }, id) => {
  const signal = state.data[id];
  if (!signal) return;

  const currentValue = signal.reactions?.bookmarked?.is_mine ?? false;

  if (!(id in state.optimisticOriginal)) {
    state.optimisticOriginal[id] = currentValue;
  }

  commit("SET_BOOKMARK_STATE", { id, value: !currentValue });

  if (!state.debounceTimers[id]) {
    state.debounceTimers[id] = debounce(async () => {
      try {
        await apiToggleFavouriteSignal({
          object_id: id,
          content_type: signal.content_type,
        });

        delete state.optimisticOriginal[id];
        commit("SAVE_FAVORITES_COUNT_TO_STORAGE");
      } catch (err) {
        console.error("Ошибка сервера, откат:", err);
        commit("SET_BOOKMARK_STATE", {
          id,
          value: state.optimisticOriginal[id],
        });
        delete state.optimisticOriginal[id];
        commit("SAVE_FAVORITES_COUNT_TO_STORAGE");
      } finally {
        delete state.debounceTimers[id];
      }
    }, 800);
  }

  state.debounceTimers[id]();
};